function webpackEmptyContext(req) {
	throw new Error("Cannot find module '" + req + "'.");
}
webpackEmptyContext.keys = function() { return []; };
webpackEmptyContext.resolve = webpackEmptyContext;
module.exports = webpackEmptyContext;
webpackEmptyContext.id = "aItp";


//////////////////
// WEBPACK FOOTER
// ./redevelopment/outputManage/stocks ^\.\/.*$
// module id = aItp
// module chunks = 0